module.exports = __webpack_public_path__ + "4d91192fab0b87e60923bbb782ccb67d.jpeg";